import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ChangeDetectorRef, Injectable, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { EquipmentSummaryService } from './equipment-summary.service';
import { ExceptionHelper } from './../../../../helper';
import { IsActive } from '../../../../model';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'app-equipment-summary',
  templateUrl: './equipment-summary.component.html'
})
export class EquipmentSummaryComponent implements AfterViewInit, OnInit {

  @ViewChild('dangerModal') dangerModal: any;

  // applied: Boolean = true;
  // activateCheckboxStatus: number;

  dataTable: any;
  equipments: any[];

  siteId;
  customerId;

  constructor(
    private chRef: ChangeDetectorRef,
    private exception: ExceptionHelper,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private equipmentSummaryService: EquipmentSummaryService,
    private translateService: TranslateService
  ) {
    translateService.setDefaultLang('en-us');
    if (this.router.url.includes('site')) {
      this.route.params.subscribe(params => {
        this.siteId = params['siteId'];
      });
    } else if (this.router.url.includes('customer')) {
      this.route.params.subscribe(params => {
        this.customerId = params['customerId'];
      });
    }

  }

  ngAfterViewInit() {
    this.getSummary();
  }

  ngOnInit() { }

  // apply() {
  //   this.getSummary();
  // }

  // checkboxStatus(input) {
  //   this.applied = input.isApply;
  //   this.activateCheckboxStatus = input.activateCheckboxStatus;
  // }

  getSummary() {

    // const all = (this.siteId == null ? true : false);

    this.equipmentSummaryService.getSummary(this.siteId, this.customerId, IsActive.active)
      .subscribe((data: any) => {
        // this.applied = true;
        if ($.fn.dataTable.isDataTable('#equipmentDataTables')) { $('#equipmentDataTables').DataTable().destroy(); }

        this.equipments = data.equipmentListModel;

        this.chRef.detectChanges();

        const table: any = $('#equipmentDataTables');
        this.dataTable = table.DataTable({
          'order': []
        });
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
      });
  }

  errorClose() {
    if (this.siteId != null) {
      this.router.navigate(['/home/site/detail/' + this.siteId]);
    } else if (this.customerId != null) {
      this.router.navigate(['/home/customers/detail/' + this.customerId]);
    } else {
      this.dangerModal.hide();
    }
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-summary/equipment-summary.component.ts